module.exports = __webpack_public_path__ + "img/sl_2.59afed70.jpg";